import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBZNANY1v0a16hPmbW7FslfErVCAIk-IrQ",
  authDomain: "mdro-app.firebaseapp.com",
  projectId: "mdro-app",
  storageBucket: "mdro-app.firebasestorage.app",
  messagingSenderId: "235813234755",
  appId: "1:235813234755:web:1c7269ec483eb1bc760cf6",
  measurementId: "G-2LCK6MDV1W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firestore
export const db = getFirestore(app);